import { isRentalManager } from "../contexts/UserContext";

/**
 * Utilisé pour les rentalManager qui ne peuvent pas faire d'action sur la copropriété
 * si rentalManagerCreateContent n'existe pas ou est à false
 * si rentalManagerCreateContent est à true, alors le rentalManager peut faire des actions sur la copropriété
 * de base on retoure true car ça ne s'applique pas aux autres types de compte
 * @param {*} user 
 * @returns 
 */
export const rentalManagerCanMakeActionOnCoownership = (user) => {
  if(isRentalManager(user)){
    return user.userData.rentalManagerCreateContent ?? false;
  }
  return true;
}